module.exports = __webpack_public_path__ + "static/media/메세지 푸쉬.ed0cf7d2.jpg";